import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { Templates } from '../components/Templates';
import { About } from '../components/About';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Quicksand', sans-serif" }}>
      <Header />
      <Hero />

      {/* Decorative divider */}
      <div className="flex items-center justify-center py-4" style={{ background: '#FFF9F5' }}>
        <div className="flex items-center gap-4">
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#F43F5E" opacity="0.3">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
        </div>
      </div>

      <Services />
      <HowItWorks />

      {/* Decorative divider */}
      <div className="flex items-center justify-center py-4" style={{ background: '#FFF9F5' }}>
        <div className="flex items-center gap-4">
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
          <svg width="28" height="24" viewBox="0 0 28 24" fill="none" opacity="0.2">
            <circle cx="10" cy="12" r="8" stroke="#10B981" strokeWidth="1.5" />
            <circle cx="18" cy="12" r="8" stroke="#10B981" strokeWidth="1.5" />
          </svg>
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
        </div>
      </div>

      <Templates />
      <About />

      {/* Decorative divider */}
      <div className="flex items-center justify-center py-4" style={{ background: '#FFF9F5' }}>
        <div className="flex items-center gap-4">
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#3B82F6" opacity="0.2">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
          <div className="w-16 h-px" style={{ background: '#E5E2DF' }} />
        </div>
      </div>

      <Contact />
      <Footer />
    </div>
  );
}
